import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'antd';
import Scrollbar from 'react-scrollbars-custom';
import Util from '../../../script/util';
import { DDEmpty } from '../../globalPageStatus';
import AtlasDetailsModal from './AtlasDetailsModal';
import HTTP from '../../../script/service';
import './SuitAtlas.scss';
import AchieveItem from '../dsUserAchieve/AchieveItem';

class SuitAtlas extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      suitList: [], // 套系列表
      list: [], // 套系中礼物列表
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.index !== this.props.index) {
      if (this.carouselElement) {
        this.setCarouselIndex(this.props.index, false);
      }
    }
  }

  componentDidMount() {
    this.getUserSuitVo();
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  // 指定轮播位置
  setCarouselIndex = (index, dontAnimate = false) => {
    if (this.carouselElement) {
      clearInterval(this.timer);
      this.carouselElement.goTo(this.props.index, dontAnimate);
    } else {
      this.timer = setInterval(() => {
        this.setCarouselIndex(index, dontAnimate);
      }, 300);
    }
  };

  // 查询所有套系
  getUserSuitVo = () => {
    const { ds } = this.props;
    this.props.dispatch({
      type: 'change_atlas_loading',
      data: { atlasLoading: true },
    });
    HTTP._get_user_suit_vo({ searchUid: ds.uid })
      .then((res) => {
        if (res?.code === 200 && res?.data?.suitItemList?.length) {
          this.setState({ suitList: res.data.suitItemList }, () => {
            // antd Carousel 的需要等待DOM渲染完成
            setTimeout(() => {
              this.setCarouselIndex(this.props.index, true);
            }, 100);
          });
          this.getSuitItemDetail(res.data.suitItemList[0]);
          this.props.updateCarouselList(res.data.suitItemList);
        } else {
          this.props.dispatch({
            type: 'change_atlas_loading',
            data: { atlasLoading: false },
          });
        }
      })
      .catch((err) => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };

  // 查询套系中所有的礼物
  getSuitItemDetail = (suit) => {
    const { ds } = this.props;
    HTTP._get_user_suit_gift({ searchUid: ds.uid, suitId: suit.suitId })
      .then((res) => {
        if (res?.code === 200) {
          this.setState({ list: res.data });
        }
      })
      .finally((res) => {
        this.props.dispatch({
          type: 'change_atlas_loading',
          data: { atlasLoading: false },
        });
      });
  };

  // 选择礼物
  onSelectCurrentSuit = (index) => {
    this.atlasDetailsElement.showModal(index);
  };

  // 切换轮播
  onCarouselAfterChange = (current) => {
    if (process.env.NODE_ENV === 'test' && current < 0) {
      // 单元测试下current返回异常，所以控制一下current
      current = 1;
    }
    const { suitList } = this.state;
    this.props.dispatch({
      type: 'change_atlas_loading',
      data: { atlasLoading: true },
    });
    this.props.onChange(current);
    this.getSuitItemDetail(suitList[current]);
  };
  // 轮播图切换
  onChangeCarousel = (type) => {
    const { carCurIndex, suitList } = this.state;
    if (suitList?.length > 1 && this.carouselElement) {
      if (type === -1) {
        this.setState({ carCurIndex: carCurIndex - 1 });
        this.carouselElement.prev();
      } else {
        this.setState({ carCurIndex: carCurIndex + 1 });
        this.carouselElement.next();
      }
    }
  };

  render() {
    const { base, ds } = this.props;
    const { atlasLoading } = base;
    const { suitList, list } = this.state;
    return (
      <div className="suit-atlas-wrap noSelect">
        <div className="suit-atlas-header">
          <div
            className="carousel-suit-mini-prev"
            onClick={() => this.onChangeCarousel(-1)}
          />
          <div className="carousel-suit-mini-center">
            <Carousel
              ref={(el) => (this.carouselElement = el)}
              dots={false}
              afterChange={this.onCarouselAfterChange}
            >
              {suitList.map((item, index) => (
                <div key={item.suitId} className="carousel-suit-mini-item">
                  <div className="suit-item-wrap">
                    <div className="cover">
                      <img
                        src={Util.transImgUrl(item?.suitIcon)}
                        alt={item.suitName}
                      />
                    </div>
                    <div className="suit-info">
                      <div className="name">{item.suitName}</div>
                      <div className="process">
                        收集：{item.suitLightGiftNum}/{item.suitGiftNum}
                      </div>
                      <div className="complete">
                        已完成：{item?.lightTimes || 0}次
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
          <div
            className="carousel-suit-mini-next"
            onClick={() => this.onChangeCarousel(1)}
          />
        </div>

        <div className="suit-atlas-content">
          {list?.length ? (
            <Scrollbar>
              {list.map((item, index) => (
                <AchieveItem
                  key={item.giftId}
                  className="suit-atlas-item"
                  status={item.lightStatus}
                  cover={item.staticPic}
                  name={item.giftName}
                  num={item.giftNum}
                  onClick={() => this.onSelectCurrentSuit(index)}
                >
                  {item?.backImgSmall && (
                    <div
                      className="suit-item-bg"
                      style={{
                        backgroundImage: `url(${Util.transImgUrl(item.backImgSmall, '136x181')})`,
                      }}
                    />
                  )}
                  {item?.rarityImg && (
                    <div
                      className="suit-tag"
                      style={{
                        backgroundImage: `url(${Util.transImgUrl(item.rarityImg)})`,
                      }}
                    />
                  )}
                </AchieveItem>
              ))}
            </Scrollbar>
          ) : (
            !atlasLoading && (
              <DDEmpty description="暂无礼物" className="suit-atlas-empty" />
            )
          )}
        </div>

        <AtlasDetailsModal
          cRef={(el) => (this.atlasDetailsElement = el)}
          ds={ds}
          list={list}
        />
      </div>
    );
  }
}

export default connect((store) => ({ base: store }))(SuitAtlas);
